import React, { memo, useMemo } from 'react'

import useDisabledSelector from 'Pods/ThreeDStudio/Hooks/useDisabledSelector'
import ButtonGroupSelector from 'Pods/ThreeDStudio/Shared/ButtonGroupSelector/ButtonGroupSelector'
import { setMaterial } from 'Pods/ThreeDStudio/Store/actions/textureSettings'
import { MATERIAL } from 'Pods/ThreeDStudio/Store/constants'

const handlePbrClick = () => setMaterial(MATERIAL.PBR)
const handleBasicClick = () => setMaterial(MATERIAL.BASIC)

function MaterialSelector() {
  const { isFullyDisabled, disabledValues } = useDisabledSelector('material', 'enhancedModelSchema')

  const buttons = useMemo(() => [
    {
      id: MATERIAL.PBR,
      label: 'PBR',
      onClick: handlePbrClick,
      disabled: isFullyDisabled || disabledValues.includes(MATERIAL.PBR),
    },
    {
      id: MATERIAL.BASIC,
      label: 'Basic Material',
      onClick: handleBasicClick,
      disabled: isFullyDisabled || disabledValues.includes(MATERIAL.BASIC),
    },
  ], [isFullyDisabled, disabledValues])

  return (
    <ButtonGroupSelector
      buttons={buttons}
      keyName="material"
      sliceName="textureSettings"
      label="Material"
    />
  )
}

export default memo(MaterialSelector)
